/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import './css/ContactUs.css'
import Fcontact from '../Shared/Fcontact';
import banner from "../../assets/imgs/contact-img.webp"
import formright from "../../assets/imgs/contactForm-img.webp"
import weare from "../../assets/imgs/c-who-we-are.webp"
import packages from "../../assets/imgs/c-packages.webp"
import sliderleaf from "../../assets/imgs/slider-leaf-1.webp"
import sliderleaf2 from "../../assets/imgs/slider-leaf-2.webp"
import NewsLetter from "../Shared/NewsLetter";
import { Helmet } from 'react-helmet';
import Aos from 'aos';
import Modal from "react-bootstrap/Modal";

const ContactUs = () => {
    const [isFormLoaded, isSetFormLoaded] = useState(false);
    const [show, setShow] = useState(false);
    const [policy, setPolicy] = useState(false);
    const handleClose = () => {
        setPolicy(false);
        setShow(false);
      };
    const handleShow = () => {
        setPolicy(true);
        setShow(true);
      };
    useEffect(() => {
        window.addEventListener('load', Aos.refresh);
        isSetFormLoaded(true);

        Aos.init({
            once: false
        })
    });
    
    useEffect(() => {
        const violation = document.getElementById("top-menu");
        window.scrollTo({
            top: violation.offsetTop,
            // behavior: "smooth",
        });
    }, []);
    
     return (
        <>
            <Helmet>
                 <title>Contact Us - Right Cause</title>
                <meta name="keywords" content="" />
                 <meta name="description" content="Connect with us easily! Reach out for Nonprofit CRM solution inquiries or any assistance you need. Our team is here to help and eager to hear from you. Let's start a conversation today!" />
            </Helmet>
            <div>
                <section>
                    <div className="contact-banner">
                        <h1 className="headingOne">Contact Us</h1>
                        <div className="innerPage-banner-img">
                            <img src={banner} alt="nonprofit fundraising solutions" width="536" height="537" />
                        </div>
                    </div>
                </section>
                <main>
                    <section id="contact-us" className="contact_usSection">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 col-lg-6 mt-xs-3">
                                    <div className="contact-getStartedForm-wrapper">
                                        <Fcontact />
                                    </div>
                                </div>
                                <div className="col-md-12 col-lg-6 contactImg-div text-center d-flex">
                                    <div className="contactImg">
                                        <div className="f-LeafTop contactLeaf-t"><img src={sliderleaf} alt="Right Cause" /> </div>
                                        <img src={formright} alt="nonprofit fundraising solutions" width="450" height="391" className="contact-img" />
                                        <div className="f-Leafbottom contactLeaf-b"><img src={sliderleaf2} alt="Right Cause" /></div>
                                    </div>
                                </div>
                            </div>

                             {
                                isFormLoaded && (                                
                                    <div className="contactForm_actionItems mt-5">
                                        <div className="row">
                                            <div className={`col-md-4 text-center`}>
                                                <div className="featured-items greenBg">
                                                    <div className="featured-img mb-3">
                                                        <div className="f-LeafTop contactLeaf-t"><img src={sliderleaf} alt="Right Cause" /> </div>
                                                        <img src={weare} alt="nonprofit fundraising solutions" width="255" height="255" />
                                                        <div className="f-Leafbottom contactLeaf-b"><img src={sliderleaf2} alt="Right Cause" /></div>
                                                    </div>
                                                    <a aria-label="Who we are link" className="f-action-link" href="/">Who we are <span className="icon-arrow"></span></a>
                                                </div>
                                            </div>

                                            <div className={`col-md-4 text-center `}>
                                                <div className="featured-items">
                                                    <div className="featured-img mb-3">
                                                        <div className="f-LeafTop contactLeaf-t"><img src={sliderleaf} alt="Right Cause" /> </div>
                                                        <img src={packages} alt="nonprofit fundraising solutions" width="255" height="255" />
                                                        <div className="f-Leafbottom contactLeaf-b"><img src={sliderleaf2} alt="Right Cause" /></div>
                                                    </div>
                                                    <a aria-label="Explore our Packages link" className="f-action-link" onClick={() => handleShow()}>Explore our Packages <span className="icon-arrow"></span>
                                                    </a>
                                                </div>

                                            </div>
                                            <div className={`col-md-4 text-center `}>
                                                <div className="featured-items">
                                                    <NewsLetter />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                             }
                        </div>
                    </section>
                </main>
                <Modal size="lg" show={show} onHide={handleClose} className="modal_getStartedForm">
                    <Modal.Header closeButton></Modal.Header>
                    <Fcontact policy={policy} onSubmit={handleClose} />
                </Modal>
            </div>
        </>
         
     )
}

export default ContactUs;